export const MAIN_API = "https://api.aik.az/public/api/v1";
